import { render, staticRenderFns } from "./apply-wx-partner.vue?vue&type=template&id=389f7756&scoped=true"
import script from "./apply-wx-partner.vue?vue&type=script&lang=ts"
export * from "./apply-wx-partner.vue?vue&type=script&lang=ts"
import style0 from "./apply-wx-partner.vue?vue&type=style&index=0&id=389f7756&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f7756",
  null
  
)

export default component.exports